import type { Address } from '../types'

import { useFormatAddress } from './useFormatAddress'

export function useInlineFormatAddress(
  address: Address,
  {
    separator = ', ',
    includeCompany = true,
    includeCountry = true,
    includeName = false,
  } = {},
) {
  return useFormatAddress(address, {
    includeCompany,
    includeCountry,
    includeName,
  }).join(separator)
}
